// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1L9qF","footer":"ReportModalFilter_footer__2Ois1"};